new Accordion(
  [
    ".accordion-container",
    ".nested-accordion-parent-1",
    ".nested-accordion-child-1",
    ".nested-accordion-parent-2",
    ".nested-accordion-child-2",
    ".nested-accordion-parent-3",
    ".nested-accordion-child-3",
    ".nested-accordion-parent-4",
    ".nested-accordion-child-4",
    ".nested-accordion-parent-5",
    ".nested-accordion-child-5",
  ],
  {
    openOnInit: [0],
    collapse: true,
    showMultiple: false,
  }
);
